import {mobileWalletSvg as Icon__small__mobileWalletSvg} from '../Icon__small/Icon__small--mobileWallet.js';

export var mobileWallet = {
  name: 'mobileWallet',
  category: 'icon',
  colorable: true,
  svg: Icon__small__mobileWalletSvg,
};
